import { includes, pull } from 'lodash';

export const addOrRemoveFromArray = <T>(arr: T[], value: T): T[] => {
  if (includes(arr, value)) {
    return pull(arr.slice(), value);
  }
  return [...arr, value];
};
